import Marionette from "backbone.marionette";
import MastersViewDetail from "views/masters/mastersViewDetail.ejs";
import MastersModel from "models/mastersModel.js";

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.LayoutView.extend({
    initialize: function(data) {
        this.id = data.id;
        this.lang = data.lang;
        this.accounts = data.accounts;
        this.model = data.model || new MastersModel();
        this.desc = data.desc;
        this.tablename = data.tablename;
        this.allaccounts = data.allaccounts;
    },
    template: MastersViewDetail,
    render: function() {
        this.$el.html(this.template({
            attributes: this.model.attributes,
            lang: this.lang,
            accounts: this.accounts,
            allaccounts: this.allaccounts,
            desc: this.desc,
            tablename: this.tablename,
            rolee: S.userInfo.get("role")
        }));
        $("#insertModal").modal('show');


        $("#dtpickerMaster").datetimepicker({ format: 'DD/MM/YYYY' });
        $("#dtpickerMaster  input").datetimepicker({ format: 'DD/MM/YYYY' });


        $('.money:not(th)').mask("#.##0,00", { reverse: true });
        $('.decimal:not(th)').mask("#.##0,00", { reverse: true });
        $('.integer:not(th)').mask("#.##0", { reverse: true });
        $('.number:not(th)').mask("##0", { reverse: true });


    },
    events: {
        "click #cancel": "cancel",
        "click #save": "save"
    },
    cancel: function() {
        this.destroy();
        $("#insertModal").modal("hide");
    },
    save: function() {

        $("#loaderContainer").show();

        var formData = {};

        var form = document.forms["masters"];

        for (var i = 0; i < form.elements.length; i++) {
            var element = form.elements[i];
            if (element.nodeName === "BUTTON")
                continue;
            else
            // If it is file, leave for later
            if ($(element).attr("type") === "file" && $(element)[0].files[0]) {
                continue;
            } else
            //In case of date, format correctly
            if ($(element).attr("id") && $(element).attr("id").indexOf("fecha") !== -1) {
                if (!$(element).val() || $(element).val() === "00/00/0000")
                    continue;
                /*var fecha = $(element).val().split("/");
                formData[$(element).attr("id")] = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
                continue;*/
            } else
            //If checkbox, tranform to boolean
            if ($(element).val() === "on") {
                formData[$(element).attr("id")] = $(element).is(':checked') ? "1" : "0";
                continue;
            }

            formData[$(element).attr("id")] = $(element).val();
        }

        formData.table = this.tablename + '_' + S.instanceId;
        formData.instanceId = S.instanceId;

        this.model.save(formData, {
            beforeSend: T.useToken,
            success: function(model, response) {
                $("#loaderContainer").hide();

                S.mApp.trigger("notify:success", {
                    message: S.userInfo.attributes.lang.INSERT_OK
                });

                S.mApp.trigger("update:masters");
                $("#insertModal").modal("hide");
            },
            error: function() {

            }
        });


        //// $("#insertModal").modal("hide");
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/masters/mastersViewDetail.js
// module id = 194
// module chunks = 0